import { Card, SkeletonThumbnail, SkeletonBodyText } from '@shopify/polaris';
import { StyledStatisticsCardSkeleton } from './styled';

const StatisticsCardSkeleton = () => (
  <StyledStatisticsCardSkeleton>
    <Card>
      <div className="statistics-card-skeleton">
        <div>
          <SkeletonThumbnail size="small" />
        </div>
        <SkeletonBodyText lines={2} />
      </div>
    </Card>
  </StyledStatisticsCardSkeleton>
);

export default StatisticsCardSkeleton;
